export var deg2rad = Math.PI / 180;
export var rad2deg = 180 / Math.PI;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-color/src/math.js
// module id = 88
// module chunks = 0